import React from 'react'

export default function PageContainer({children}) {
  return <div className='w-3/4 m-auto' >{children}</div>;
}
